"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var input_option_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/input_option_store"));
var checkbox_input_option_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/checkbox_input_option"));
var CheckboxInputOptionStore = /** @class */ (function (_super) {
    __extends(CheckboxInputOptionStore, _super);
    function CheckboxInputOptionStore(props) {
        var _this = _super.call(this, props) || this;
        _this.component = checkbox_input_option_1.default;
        _this.handleChange = function (event) {
            _this.isChecked = event.target.checked;
        };
        _this.handleBlur = function () {
            _this.onBlur && _this.onBlur(_this.isChecked ? _this.value : undefined);
        };
        _this.name = props.name;
        _this.isChecked = props.checked || false;
        _this.onBlur = props.onBlur;
        return _this;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], CheckboxInputOptionStore.prototype, "isChecked", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CheckboxInputOptionStore.prototype, "handleChange", void 0);
    return CheckboxInputOptionStore;
}(input_option_store_1.default));
exports.default = CheckboxInputOptionStore;
